export const OPERATING_MODE_ICON: { [key: string]: string } = {
  dhwAndHeating: 'water-heating',
  dhw: 'water',
  heating: 'heating',
  forcedNormal: 'forced-normal',
  forcedReduced: 'reduced',
  normal: 'normal',
  reduced: 'reduced',
  standby: 'standby',
  external: 'external',
  normalStandby: 'normal-standby',
  dhwAndHeatingCooling: 'dhw-heating-cooling',
  cooling: 'cooling',
  dhwAndCooling: 'dhw-cooling',
  heatingCooling: 'heating-cooling',
  default: 'placeholder-off-dash',
  auto: 'auto-mode',
  testMode: 'test-mode',
};

export const VENTILATION_MODE_ICON: { [key: string]: string } = {
  standby: 'standby',
  standard: 'ventilation-step-1',
  ventilation: 'ventilation-step',
  default: 'placeholder-off-dash',
};

export const VENTILATION_PROGRAM_ICON: { [key: string]: string } = {
  levelOne: 'ventilation-step-1',
  levelTwo: 'ventilation-step-2',
  levelThree: 'ventilation-step-3',
  levelFour: 'ventilation-step-4',
  standby: 'standby',
  default: 'placeholder-off-dash',
};

export const WIFI_STRENGTH_ICON: { [key: string]: string } = {
  off: 'wifi-signal-off',
  veryWeak: 'wifi-signal-very-weak',
  weak: 'wifi-signal-weak',
  ok: 'wifi-signal-ok',
  strong: 'wifi-signal-strong',
  default: 'wifi-signal-off',
  excellent: 'wifi-signal-strong',
  good: 'wifi-signal-ok',
  medium: 'wifi-signal-weak',
  low: 'wifi-signal-very-weak',
};

export const ZIGBEE_STRENGTH_ICON: { [key: string]: string } = {
  ok: 'wifi',
  weak: 'wifi',
  dying: 'wifi_off',
};

export const BATTERY_LEVEL_ICON: { [key: string]: string } = {
  ok: 'battery_full',
  weak: 'battery_alert',
  dying: 'battery_alert',
};

export const FUEL_CELL_MODE_ICON: { [key: string]: string } = {
  ecological: 'eco',
  economical: 'economical',
  heatControlled: 'heat-controlled',
  maintenance: 'maintenance',
  standby: 'standby',
  default: 'placeholder-off-dash',
};
